import { render, staticRenderFns } from "./SnippetFrame.vue?vue&type=template&id=5368f179&scoped=true"
import script from "./SnippetFrame.vue?vue&type=script&lang=js"
export * from "./SnippetFrame.vue?vue&type=script&lang=js"
import style0 from "./SnippetFrame.vue?vue&type=style&index=0&id=5368f179&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5368f179",
  null
  
)

export default component.exports